var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"keep_color w-100",attrs:{"color":"red darken-3"},on:{"click":_vm.destroy_req}},[_vm._v("Destroy Account")])}
var staticRenderFns = []

export { render, staticRenderFns }